import { BaseCommand } from './BaseCommand';
import { goto } from '$app/navigation';
import { intervalToMs } from '$lib/utils/interval';

export class RevenueCommand extends BaseCommand {
  getKeywords(): string[] {
    return ['revenue'];
  }

  parameterDescriptions = [
    { key: 'Start Date or Interval', description: "Start date (yyyy-mm-dd) or interval (e.g., 1m, 5d). Default 1 month." },
    { key: 'End Date', description: 'The end date of the interval (yyyy-mm-dd), default today.' },
  ];

  action(parameters: string[]) {
    const startInput = parameters[0];
    const endInput = parameters[1];

    const endDate = new Date();
    if (endInput && endInput !== '-') {
      endDate.setTime(new Date(endInput).getTime());
    }
    const endMs = endDate.getTime().toString();

    const startDate = new Date();
    startDate.setMonth(startDate.getMonth() - 1);
    if (startInput && startInput !== '-') {
      try {
        if (/^(\d+)([hdwm])$/.test(startInput)) {
          startDate.setTime(endDate.getTime() - intervalToMs(startInput));
        } else {
          startDate.setTime(new Date(startInput).getTime());
        }
      } catch (e) {
        return Promise.reject(new Error('Invalid start date or interval format.'));
      }
    }
    const startMs = startDate.getTime().toString();

    goto(`/admin/revenue/${startMs}/${endMs}`);
    return Promise.resolve();
  }
}
